import React, { useRef, useEffect } from "react";
import { Heart } from "lucide-react";
import profile from "../utils/profile_data";
import { useNavigate } from "react-router-dom";
import { useModelProfile } from "../context/model_profile_context"; // Import the context hook

const MeetTheModelComp = () => {
  const navigate = useNavigate();
  const modalRef = useRef(null); // Create a ref for the modal content
  const { setShowNextStepModal } = useModelProfile(); // Use the context to get the setter

  // Effect to handle clicks outside the modal
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowNextStepModal(false); // Close the modal if clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setShowNextStepModal]);

  return (
    <div className="w-full h-full fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-70 overflow-y-scroll">
      {/* Backdrop with blur effect */}
      {/* <div className="absolute inset-0 bg-slate-950/80 backdrop-blur-md"></div> */}

      {/* Modal content */}
      <div
        ref={modalRef} // Attach the ref to the modal content
        className="flex flex-col bg-gradient-to-b from-red-900/90 to-slate-950 rounded-xl overflow-hidden w-full max-w-md mx-4 shadow-xl animate-fade-in"
      >
        {/* Close button */}
        <div className="flex justify-end">
          <button onClick={() => setShowNextStepModal(false)} className="mt-2 mr-2 text-white hover:text-red-400">
            <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Top section with heart icon */}
        <div className="text-center">
          <div className="mx-auto sm:w-24 sm:h-24 w-[4rem] h-[4rem] rounded-full border border-white/20 flex items-center justify-center sm:mb-8 mb-5">
            <Heart size={36} className="text-white" />
          </div>

          <h2 className="sm:text-4xl text-2xl font-bold text-white sm:mb-4 mb-2">Meet {profile.name}</h2>
        </div>

        <div className="px-6 mb-3 sm:text-xl xsm:text-lg text-white/90 text-center">She's always ready for a good time...</div>

        {/* Quote section */}
        <div className="bg-slate-950/80 mx-6 p-2 rounded-lg">
          <p className="text-white/90 text-center sm:text-lg text-base italic">
            "I'm in bed right now touching myself... wish I had someone to talk to who knows what I like. Someone I can text when I'm feeling frisky.
            I'd love to show you what I look like without these clothes on... Maybe we could even have some fun on video later?"
          </p>
        </div>

        <div className="mx-6 mt-5 mb-5">
          <button
            onClick={() => navigate("/sign-up")}
            className="w-full py-3 rounded-lg bg-gradient-to-r from-red-900 to-red-700 text-white font-semibold mb-4 relative overflow-hidden group animate-glow hover:shadow-lg hover:shadow-red-900/20 transition-all"
          >
            <span className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-red-400/0 via-white/20 to-red-400/0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></span>
            Create Free Account
          </button>

          <p className="text-center text-sm text-pink-300">
            Already have an account?{" "}
            <span onClick={() => navigate("/login")} className="text-red-400 hover:underline cursor-pointer">
              Log in
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default MeetTheModelComp;
